import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { Box, Description, DescriptionText } from './theme'

const FrameSettings = ({ width, height, show, isSidebarOpen = false }) => (
  <Fragment>
    {show && (
      <Box isSidebarOpen={isSidebarOpen}>
        <Description>
          <DescriptionText>
            <strong>Wymiary:</strong> {width} x {height}
            cm
          </DescriptionText>
        </Description>
      </Box>
    )}
  </Fragment>
)

FrameSettings.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  show: PropTypes.bool,
  isSidebarOpen: PropTypes.bool,
}

export default FrameSettings



// WEBPACK FOOTER //
// ./src/components/FrameSettings/index.js